var _mask;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CirclePlay = function CirclePlay(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 23 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 23 23",
    fill: "none",
    className: className,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5 14.6V9.4l2.809 2.6-2.809 2.6zm.839-7.147a1.709 1.709 0 00-1.851-.307c-.61.266-.988.835-.988 1.484v6.74c0 .65.378 1.219.988 1.485.223.098.46.145.693.145.423 0 .838-.155 1.157-.451l3.642-3.37a1.61 1.61 0 00.52-1.18c0-.442-.189-.872-.52-1.177l-3.641-3.37zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
      fill: !ignoreColor ? color : undefined
    }), _mask || (_mask = /*#__PURE__*/_jsx("mask", {
      id: "prefix__a",
      maskUnits: "userSpaceOnUse",
      x: 2,
      y: 2,
      width: 20,
      height: 20,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5 14.6V9.4l2.809 2.6-2.809 2.6zm.839-7.147a1.709 1.709 0 00-1.851-.307c-.61.266-.988.835-.988 1.484v6.74c0 .65.378 1.219.988 1.485.223.098.46.145.693.145.423 0 .838-.155 1.157-.451l3.642-3.37a1.61 1.61 0 00.52-1.18c0-.442-.189-.872-.52-1.177l-3.641-3.37zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
        fill: "#fff"
      })
    })), /*#__PURE__*/_jsx("g", {
      mask: "url(#prefix__a)",
      children: /*#__PURE__*/_jsx("path", {
        fill: !ignoreColor ? color : undefined
      })
    })]
  });
};
export default CirclePlay;